// Loads Google Analytics 4 / Google Tag Manager / Search Console verification
// only when the corresponding env vars are provided at build time.
// Set in frontend/.env:
//   REACT_APP_GA4_ID=G-XXXXXXX
//   REACT_APP_GTM_ID=GTM-XXXXXXX      (optional)
//   REACT_APP_GSC_VERIFICATION=xxxxx  (Search Console HTML-tag method)

export function initAnalytics() {
  const GA4 = process.env.REACT_APP_GA4_ID;
  const GTM = process.env.REACT_APP_GTM_ID;
  const GSC = process.env.REACT_APP_GSC_VERIFICATION;

  if (GSC) {
    const meta = document.createElement('meta');
    meta.name = 'google-site-verification';
    meta.content = GSC;
    document.head.appendChild(meta);
  }

  if (GTM) {
    (function (w, d, s, l, i) {
      w[l] = w[l] || [];
      w[l].push({ 'gtm.start': new Date().getTime(), event: 'gtm.js' });
      const f = d.getElementsByTagName(s)[0];
      const j = d.createElement(s);
      const dl = l !== 'dataLayer' ? '&l=' + l : '';
      j.async = true;
      j.src = 'https://www.googletagmanager.com/gtm.js?id=' + i + dl;
      f.parentNode.insertBefore(j, f);
    })(window, document, 'script', 'dataLayer', GTM);
  }

  if (GA4) {
    const s = document.createElement('script');
    s.async = true;
    s.src = `https://www.googletagmanager.com/gtag/js?id=${GA4}`;
    document.head.appendChild(s);
    window.dataLayer = window.dataLayer || [];
    function gtag() {
      window.dataLayer.push(arguments);
    }
    window.gtag = gtag;
    gtag('js', new Date());
    gtag('config', GA4);
  }
}
